import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getFeedKey, getPostKey, getPostsKey } from '../../utils/keys';
import { pinnedPostsFilter } from './filters';
export const useMovePost = (options) => {
    const { useMutationOptions, fields } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(variables => client.posts.movePost(variables, fields), {
        onSettled: (data, error, variables) => {
            const postKey = getPostKey({ variables: { id: variables.id } });
            queryClient.invalidateQueries(postKey);
            const postsKey = getPostsKey();
            queryClient.invalidateQueries(postsKey);
            queryClient.invalidateQueries({ ...pinnedPostsFilter, active: true });
            const feedKey = getFeedKey();
            queryClient.invalidateQueries(feedKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useMovePost.js.map